(() => {
  if (window.lmReady) return;
  window.lmReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Поява при скрол */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
  const scan = (root = document) => {
    root.querySelectorAll('[data-lm-reveal]:not(.is-in), [data-lm-in]:not(.is-in)').forEach((el) => {
      if (!io || reduce) el.classList.add('is-in'); else io.observe(el);
    });
  };
  window.lmScan = scan;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (e) => scan(e.target));

  /* Бутон нагоре */
  const initTop = () => {
    const b = document.querySelector('[data-lm-totop]');
    if (!b) return;
    const u = () => b.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', u, { passive: true }); u();
    b.addEventListener('click', (e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTop); else initTop();

  /* Пари */
  window.lmMoney = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');

  /* Промяна на количеството в количката (оферти) */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-lm-coffer]');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    try {
      const body = { id: btn.dataset.key, quantity: +btn.dataset.qty };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      const res = await fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      const json = await res.json();
      if (drawer && json.sections && !document.getElementById('main-cart-items')) drawer.renderContents(json);
      else window.location.reload();
    } catch (err) { btn.disabled = false; }
  });
})();
